import React from 'react';

/*
    - ihoDesignSystem
*/
import { Accordion, Box, Button, Image, Tooltip, Typography } from '@iho-design-system/Loader';

/*
    - icons
*/
import ShareSVG from '../assets/images/icons/share.svg';

/*
    - api
*/
import likeQuestionAPI from '../api/add/LikeQuestion';

const LeftBar = ({ props, toggleTabprops }) => {

    /*
        - defaultData
    */
    const [platformQuestions, setPlatformQuestions] = React.useState([]);

    const [phf, setPhf] = React.useState(-1)

    React.useEffect(() => {
        if (props.platformQuestions.status === 200) {
            setPlatformQuestions(props.platformQuestions.data);
        }
    }, [props]);

    /*
        - likeQuestion
    */
    const likeQuestion = async (contentId, userAction, event) => {
        event.target.closest('div').querySelector('small:nth-of-type(2)').classList.add('text-dark');
        event.target.closest('div').querySelector('small:nth-of-type(2)').style.backgroundColor = 'var(--gray-medium)';
        event.target.closest('div').querySelector('small:nth-of-type(3)').classList.add('text-dark');
        event.target.closest('div').querySelector('small:nth-of-type(3)').style.backgroundColor = 'var(--gray-medium)';
        let parameters = {};
        parameters.ContentId = contentId;
        parameters.UserAction = userAction;
        let result = await likeQuestionAPI(parameters);
        if (result === 'success') {
            event.target.classList.remove('text-dark');
            event.target.classList.add('text-white');
            event.target.style.backgroundColor = 'var(--gray-dark)';
        }
    }

    /*
        - copyLink
    */
    const copyLink = (id) => {
        navigator.clipboard.writeText(`${window.location.origin}/help/?id=${id}`);
    }

    /*
        - scrollQuestion
    */
    React.useEffect(() => {
        if (props.selectedQuestion !== '') {
            let questionList = document.querySelector(`.questionList${props.selectedQuestion}`);
            setPhf(props.selectedQuestion);
            setTimeout(() => {
                window.scroll({
                    top: questionList.offsetTop,
                    left: 0,
                    behavior: 'smooth'
                });
            }, 50);
        }

        if (props.scrollQuestion !== '') {
            let questionHeaders = document.querySelectorAll('.questionHeader');
            questionHeaders.forEach((obj) => {
                if (props.scrollQuestion === obj.textContent) {
                    window.scroll({
                        top: obj.offsetTop - 12,
                        left: 0,
                        behavior: 'smooth'
                    });
                }
            });
        }

        if (props.selectedQuestion === '' && props.scrollQuestion === '') {
            let questionList = document.querySelector(`.questionList${props.searchParameter}`);
            setPhf(+props.searchParameter);
            window.scroll({
                top: questionList?.offsetTop,
                left: 0,
                behavior: 'smooth'
            });
        }

    });

    return (

        <React.Fragment>

            <Typography
                component='h3'
                className={`my-xl mt-0`}>
                سوالات متداول
            </Typography>
            <Box
                className={`p-lg border-solid border-medium rounded-lg`}
                ms={{
                    backgroundColor: 'var(--gray-light)'
                }}>
                {platformQuestions.map((obj, index) => {
                    return (
                        <React.Fragment
                            key={index}>
                            <Typography
                                component='h4'
                                className={`questionHeader my-lg mb-0 py-sm px-sm pt-0 `}>
                                {obj.Title}
                            </Typography>
                            <Accordion
                                ms={{
                                    boxShadow: 'none'
                                }}>
                                {obj.Contents.map((obj, index) => {
                                    return (
                                        <Accordion.Wrapper
                                            key={index}
                                            className={`questionList${obj.Id}`}>
                                            <Accordion.Header>
                                                {obj.Title}
                                            </Accordion.Header>
                                            <Accordion.Body
                                                active={obj.Id === phf ? true : false}>
                                                <Typography
                                                    className={`text-justify`}>
                                                    {obj.TextContent}
                                                </Typography>
                                                {obj.Actions !== null &&
                                                    <Box>
                                                        {obj.Actions[0].ActionTypeId === 0 &&
                                                            <Button
                                                                onClick={() => toggleTabprops('modifyRoom')}
                                                                className={`my-sm mb-0`}
                                                                color='primary'
                                                                size='sm'>
                                                                درخواست تغییر یا حذف اتاق
                                                            </Button>
                                                        }
                                                        {obj.Actions[0].ActionTypeId === 1 &&
                                                            <Button
                                                                onClick={() => toggleTabprops('cancel')}
                                                                className={`my-sm mb-0`}
                                                                color='primary'
                                                                size='sm'>
                                                                درخواست کنسل کردن رزرو
                                                            </Button>
                                                        }
                                                        {obj.Actions[0].ActionTypeId === 2 &&
                                                            <Button
                                                                onClick={() => toggleTabprops('modifyDate')}
                                                                className={`my-sm mb-0`}
                                                                color='primary'
                                                                size='sm'>
                                                                درخواست تغییر تاریخ رزرو
                                                            </Button>
                                                        }
                                                        {obj.Actions[0].ActionTypeId === 3 &&
                                                            <Button
                                                                onClick={() => toggleTabprops('extraPassenger')}
                                                                className={`my-sm mb-0`}
                                                                color='primary'
                                                                size='sm'>
                                                                درخواست افزودن نفر اضافه
                                                            </Button>
                                                        }
                                                        {obj.Actions[0].ActionTypeId === 4 &&
                                                            <Button
                                                                onClick={() => toggleTabprops('halfCharge')}
                                                                className={`my-sm mb-0`}
                                                                color='primary'
                                                                size='sm'>
                                                                درخواست افزودن نیم شارژ
                                                            </Button>
                                                        }
                                                        {obj.Actions[0].ActionTypeId === 5 &&
                                                            <Button
                                                                onClick={() => toggleTabprops('hotelInfo')}
                                                                className={`my-sm mb-0`}
                                                                color='primary'
                                                                size='sm'>
                                                                اطلاعات هتل
                                                            </Button>
                                                        }
                                                        {obj.Actions[0].ActionTypeId === 6 &&
                                                            <Button
                                                                onClick={() => toggleTabprops('modifyPassenger')}
                                                                className={`my-sm mb-0`}
                                                                color='primary'
                                                                size='sm'>
                                                                درخواست تغییر اطلاعات مسافران
                                                            </Button>
                                                        }
                                                        {obj.Actions[0].ActionTypeId === 7 &&
                                                            <Button
                                                                onClick={() => toggleTabprops('transfer')}
                                                                className={`my-sm mb-0`}
                                                                color='primary'
                                                                size='sm'>
                                                                درخواست ترنسفر
                                                            </Button>
                                                        }
                                                        {obj.Actions[0].ActionTypeId === 8 &&
                                                            <Button
                                                                onClick={() => toggleTabprops('invoice')}
                                                                className={`my-sm mb-0`}
                                                                color='primary'
                                                                size='sm'>
                                                                فاکتور رسمی
                                                            </Button>
                                                        }
                                                    </Box>
                                                }
                                                <Box
                                                    className={`d-flex justify-content-between align-item-center my-lg mb-0`}
                                                    sx={{
                                                        alignItems: 'center'
                                                    }}>
                                                    <Box>
                                                        <Typography
                                                            component={`small`}>
                                                            آیا این مطلب مفید بود؟
                                                        </Typography>
                                                        <Typography
                                                            onClick={(event) => likeQuestion(obj.Id, '1', event)}
                                                            component={`small`}
                                                            className={`mx-sm text-center rounded-xl`}
                                                            ms={{
                                                                width: '30px',
                                                                backgroundColor: `var(--gray-medium)`
                                                            }}>
                                                            بله
                                                        </Typography>
                                                        <Typography
                                                            onClick={(event) => likeQuestion(obj.Id, '0', event)}
                                                            component={`small`}
                                                            className={`rounded-xl text-center`}
                                                            ms={{
                                                                width: '30px',
                                                                backgroundColor: `var(--gray-medium)`
                                                            }}>
                                                            خیر
                                                        </Typography>
                                                    </Box>
                                                    <Tooltip>
                                                        <Image
                                                            onClick={() => copyLink(obj.Id)}
                                                            component='img'
                                                            src={ShareSVG}
                                                            ms={{
                                                                width: '18px',
                                                                height: '18px'
                                                            }} />
                                                        <Tooltip.Text
                                                            position='right'>
                                                            کپی لینک
                                                        </Tooltip.Text>
                                                    </Tooltip>
                                                </Box>
                                            </Accordion.Body>
                                        </Accordion.Wrapper>
                                    );
                                })}
                            </Accordion>
                        </React.Fragment>
                    );
                })}
            </Box>

        </React.Fragment>

    );

}

export default LeftBar;